import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import spinnerLottie from '@/assets/lotties/spinner.lottie'

interface Props {
  className?: string
  label?: string
}
export default memo(function LoadingIcon({className, label}: Props) {
  return (
    <DotLottieReact
      src={spinnerLottie}
      autoplay
      loop
      className={className}
      aria-label={label}
      aria-hidden={!label}
      role='progressbar'
    />
  )
})
